// import { RIDER_TYPES } from "@ipru-common/constants/SignatureUlipRider";

// class QuoteFormStore {
//   constructor() {
//     /**
//      * @type {SavingsQuoteForm}
//      */
//     this.quoteFormData = {};
//     /**
//      * @type {SavingsQuoteForm}
//      */
//     this.premiumRates = {};
//     /**
//      * @type {AllocatedFund[]}
//      */
//     this.defaultAllocatedFunds = [];
//     /**
//      * @type {AllocatedFund[]}
//      */
//     this.selectedFunds = [];
//     this.negativePincodes = {};
//   }

//   setQuoteFormData(quoteFormData) {
//     this.quoteFormData = quoteFormData;
//   }

//   /**
//    * @returns {SavingsQuoteForm}
//    */
//   getQuoteFormData() {
//     return this.quoteFormData;
//   }

//   setPremiumRates(premiumRates) {
//     this.premiumRates = premiumRates;
//   }
//   /**
//    * @returns {SavingsQuoteForm}
//    */
//   getPremiumRates() {
//     return this.premiumRates;
//   }

//   setDefaultAllocatedFunds(defaultAllocatedFunds) {
//     this.defaultAllocatedFunds = defaultAllocatedFunds;
//   }

//   /**
//    * @returns {AllocatedFund[]}
//    */
//   getDefaultAllocatedFunds() {
//     return this.defaultAllocatedFunds;
//   }

//   setField(fieldName, value) {
//     this.quoteFormData[fieldName] = value;
//   }

//   setPaymentOption(paymentOption) {
//     this.quoteFormData.paymentOption = paymentOption;
//   }

//   setPaymentFrequency(paymentFrequency) {
//     this.quoteFormData.paymentFrequency = paymentFrequency;
//   }

//   setInvest(invest) {
//     this.quoteFormData.invest = invest;
//   }

//   setLifeCover(lifeCover) {
//     this.quoteFormData.lifeCover = lifeCover;
//   }

//   setPpt(ppt) {
//     this.quoteFormData.ppt = ppt;
//   }

//   setTerm(term) {
//     this.quoteFormData.term = term;
//   }

//   setAllocatedFunds(fundAllocation) {
//     this.quoteFormData.allocatedFunds = fundAllocation;
//   }

//   setSelectedFunds(selectedFunds) {
//     this.selectedFunds = selectedFunds;
//   }

//   getSelectedFunds() {
//     return this.selectedFunds;
//   }

//   updateFields(fields) {
//     this.quoteFormData = { ...this.quoteFormData, ...fields };
//   }

//   setNegativePincodes(negativePincodes) {
//     this.negativePincodes = negativePincodes;
//   }

//   getNegativePincodes() {
//     return this.negativePincodes;
//   }

//   checkOnlyWOPRiderSelected() {
//     const wopRider = this?.quoteFormData?.selectedRiders?.find((current) => current?.sectionName === RIDER_TYPES.WOP);
//     return wopRider;
//   }

//   setMasterData(masterData) {
//     this.masterData = masterData;
//   }

//   getMasterData() {
//     return this.masterData || {};
//   }
// }
//   getMasterData() {
//     return this.masterData || {};
//   }
//   setJointLife(value) {
//     this.quoteFormData.isJointLife = value;
//   }
//   isJointLife() {
//     return this.quoteFormData.isJointLife;
//   }
//   isSingleLifeWithROP_CI_CD() {
//     return this.quoteFormData?.selectedAnnuityOption?.annuityOption === OPTION_VALUES.ANNUITY_OPTIONS.ME_NOMINEE[2];
//   }
// }

import { QuoteFormStoreInstance as QuoteFormStore } from "shared-library";

export default QuoteFormStore;
